import { Link } from 'react-router-dom';

const linkGroups = [
  {
    title: '新闻频道',
    links: [
      { label: '社会热点', path: '/category/society' },
      { label: '娱乐资讯', path: '/category/entertainment' },
      { label: '生活动态', path: '/category/life' },
      { label: '搜索爆料', path: '/search' },
    ],
  },
  {
    title: '关于爆料网',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/contact' },
      { label: '版权声明', path: '/about' },
      { label: '免责声明', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-50/70">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-megaphone-fill text-lg" />
            </span>
            <span className="font-heading text-xl font-black text-background-50">爆料网</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-6">
            爆料网致力于提供最新、最全面的新闻爆料和事件报道，涵盖社会热点、娱乐资讯及生活动态，帮助用户第一时间了解重要新闻事件。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {['ri-wechat-line', 'ri-weibo-line', 'ri-qq-line', 'ri-mail-line'].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-900 text-background-50/80 transition-colors hover:bg-accent-500 hover:text-primary-950"
              >
                <i className={`${icon} text-lg`} />
              </span>
            ))}
          </div>
        </div>

        {linkGroups.map((group) => (
          <div key={group.title}>
            <h4 className="font-heading text-base font-bold text-background-50">{group.title}</h4>
            <ul className="mt-4 space-y-3">
              {group.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-sm transition-colors hover:text-accent-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs sm:flex-row md:px-6">
          <p>© 2026 爆料网 baoliao.com 版权所有 · 未经授权禁止转载</p>
          <p>本站演示内容均为虚构示例，不含真实敏感信息</p>
        </div>
      </div>
    </footer>
  );
}